import * as React from 'react';
import { TabsContext } from './SettingPopupTabs';

const panelStyle: React.CSSProperties = {
  // ウィンドウ縦が狭い場合にある程度までダイアログを縮めて中身をスクロール出来るように
  // ダイアログ内コンテンツ表示領域の高さを指定する
  //
  // 本当は外側であるダイアログのサイズを調整することで実現したいが、flexboxの挙動に
  // ブラウザ間の差異があり動作が安定しないため、100vhを基準に
  // ・ダイアログのタイトルバー分の高さ
  // ・上下padding
  // ・上下border
  // ・ダイアログ上下の余白分
  // を引いたものを直接指定する
  // ※ IE11, Edge Ver 42.17134.1.0では縮めて伸ばしても伸びきらない
  height: 'calc(100vh - 43px - 16px - 22px - 4px - 2em)',
  padding: '16px 20px 22px 18px',
  overflow: 'auto',
};

interface SettingPopupTabPanelProps {
  style?: React.CSSProperties;
}

const SettingPopupTabPanel: React.SFC<SettingPopupTabPanelProps> = (props) => {
  return (
    <TabsContext.Consumer>{(state) => {
      return (
        <div style={{ ...panelStyle, ...props.style }}>
          {(props.children as HTMLElement[])[state.selectedTabIndex]}
        </div>
      );
    }}</TabsContext.Consumer>
  );
};

export default SettingPopupTabPanel;
